import EventBus from '../../../shared/js/wirebox/event-bus'
import '../../../shared/js/wirebox/modules/storage'
import '../../../shared/js/wirebox/utilities/get-hidden-input'
import jQuery from 'jquery'

/**
 * Add gclid hidden input to form upon submission
 * @param form
*/
const FormGClid = (form) => {
    
    //Cancel if form does not contain necessary class
    if (!form.hasClass('add-gclid')) {
        return
    }
    
    //Attempt to retrieve gclid from local storage
    EventBus.publish('storage.read', {
        callback: (gclidString) => {
            
            //Cancel if no gclid within local storage
            if (!gclidString) {
                return
            }
            
            //Convert stored gclid JSON string in to object
            let gclid = JSON.parse(gclidString)
            
            //Get timestamp
            let
                date = new Date(),
                timestamp = Math.floor(date / 1000)
                
            //Cancel if gclid is older than 90 days
            if (gclid.timestamp < timestamp - (60 * 60 * 24 * 90)) {
                return
            }
            
            //Generate hidden form input and apply glid value to it
            EventBus.publish('get-hidden-input', {
                callback: (input) => {
                    input.val(gclid.value)
                },
                form: form,
                name: 'gclid'
            })
            
        },
        key: 'gclid'
    })
    
}

EventBus.subscribe('form-submitting', FormGClid)

export default FormGClid